export const saveUserInfo = (response) => {
  if(response.status === 200) {
    return {
      success: true
    };
  }
  if (response.status === 201) {
    return {
      success: false,
      suggestions: response.data
    };
  }
  return {
    success: true
  };
}